module.exports = __webpack_public_path__ + "img/PW.761273ab.svg";